export default {
  getType: state => state.type,
  getDocument: state => state.document,
  getRG: state => state.rg,
  getName: state => state.name,
  getBirthDate: state => state.birthDate,
  getMotherName: state => state.motherName,
  getFatherName: state => state.fatherName,
  getGender: state => state.gender,
  getSchooled: state => state.schooled,
  getMaritalStatus: state => state.maritalStatus,
  getProfession: state => state.profession,

  getCompanyName: state => state.companyName,
  getCompanyType: state => state.companyType,
  getOpeningDate: state => state.openingDate,
  getResponsible: state => state.responsible,
  getResponsibleName: state => state.responsible.name,
  getResponsibleCpf: state => state.responsible.cpf,
  getStateRegistration: state => state.stateRegistration,
  getContactName: state => state.contactName,

  getEmail: state => state.email,
  getCellphone: state => state.cellphone,
  getLandline: state => state.landline,
  getAnotherContact: state => state.anotherContact,
  getNote: state => state.note,

  getClient: state => {
    return {
      type: state.type,
      document: state.document,
      rg: state.rg,
      name: state.name,
      birthDate: state.birthDate,
      motherName: state.motherName,
      fatherName: state.fatherName,
      gender: state.gender,
      schooled: state.schooled,
      maritalStatus: state.maritalStatus,
      profession: state.profession,
      companyName: state.companyName,
      companyType: state.companyType,
      openingDate: state.openingDate,
      responsible: state.responsible,
      stateRegistration: state.stateRegistration,
      contactName: state.contactName,
      email: state.email,
      cellphone: state.cellphone,
      landline: state.landline,
      anotherContact: state.anotherContact,
      note: state.note
    }
  }
}
